export const CERTIFICATION_SCREENING_TYPE = 'CERTIFICATE'

/** The question whose answer decides whether the organisation is asked to attach its policy document. */
export const CERTIFICATE_POLICY_QUESTION_ID = 'certificate_policy_documented'

/** The answer to {@link CERTIFICATE_POLICY_QUESTION_ID} that means there is no policy to attach. */
export const POLICY_ANSWER_NO_POLICY = 'no'

/** Mirrors the multer limits on POST /api/private/screening/:screeningId/certificate. */
export const CERTIFICATION_DOCUMENT_MAX_FILES = 10
export const CERTIFICATION_DOCUMENT_MAX_BYTES = 5 * 1024 * 1024
export const CERTIFICATION_DOCUMENT_ACCEPTED_FILES = { 'application/pdf': ['.pdf'] }

export type CertificationScreening = {
  id: string
  screeningCode: string
  completed: boolean
  handledAt: string | null
}
